import React, { useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P208List({ dataTable, goPage, actionMenuColumn }) {
    const history = useHistory();
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

    const headerLabel = <span className="hidden-responsive">กลับหน้าจอหลัก</span>;
    const header = (
        <div className="table-header">
            <Button
                className="p-button p-button-secondary btn-hidden-responsive"
                label={headerLabel}
                icon="pi pi-arrow-left"
                // onClick={() => goPage(200)}
                onClick={() => history.push("/200")}
                autoFocus
            />
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            {/* <div className="card"> */}
            <DataTable
                // ref={(el) => dt = el}
                value={dataTable}
                dataKey="id"
                paginator
                first={pageConf.first}
                rows={pageConf.rows}
                onPage={(e) => onPageChange(e, setPageConf)}
                rowsPerPageOptions={rowsPerPageOptions()}
                paginatorTemplate={paginatorTemplate()}
                currentPageReportTemplate={currentPageReportTemplate()}
                header={header}
                // globalFilter={globalFilter}
                emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                selectionMode="single"
            >
                <Column sortable field="contractNoForDisplay" header="เลขที่สัญญา" body={(e) => normalColumn(e, "contractNoForDisplay", "เลขที่สัญญา")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="routeName" header="เส้นทาง" body={(e) => normalColumn(e, "routeName", "เส้นทาง")} style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="contractorName" header="ผู้รับเหมา" body={(e) => normalColumn(e, "contractorName", "ผู้รับเหมา")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="contractType" header="ประเภทสัญญา" body={(e) => normalColumn(e, "contractType", "ประเภทสัญญา")} style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="contractPeriod" header="ช่วงวันที่" body={(e) => normalColumn(e, "contractPeriod", "ช่วงวันที่")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                <Column field="remainDay" header="จำนวนวันที่เหลือ" body={(e) => normalColumn(e, "remainDay", "จำนวนวันที่เหลือ")} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="contractAmount" header="มูลค่า" body={(e) => normalColumn(e, "contractAmount", "มูลค่า")} style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="withdrawAmount" header="เบิกเงินแล้ว" body={(e) => normalColumn(e, "withdrawAmount", "เบิกเงินแล้ว")} style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="withdrawPercent" header="%" body={(e) => normalColumn(e, "withdrawPercent", "%")} style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="supervisorName" header="ผู้คุมงาน" body={(e) => normalColumn(e, "supervisorName", "ผู้คุมงาน")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="contractStatus" header="สถานะสัญญา" body={(e) => normalColumn(e, "contractStatus", "สถานะสัญญา")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="caseName" header="" body={(e) => actionMenuColumn(e)} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
            </DataTable>
            {/* </div> */}
        </div>
    );
}
